























// @ts-ignore
import {VTextarea} from 'vuetify/lib/components';
import SimpleKeyboard from '@/components/SimpleKeyboard.vue';
import {Component, Inject, Prop, Vue} from 'vue-property-decorator';
import {IGlobalConfigs} from '@/setup/GlobalConfigs/IGlobalConfigs';
import {i18n} from '@/plugins/i18n';

@Component({
  name: 'VTextAreaOutlined',
  components: {
    SimpleKeyboard,
  },
  extends: VTextarea,
})
export default class VTextAreaOutlined extends Vue {

  @Inject({from: Symbol.for('GlobalConfigs')}) globalConfigs!: IGlobalConfigs;


  @Prop({
    default: true,
    type: Boolean,
  }) outlined!: boolean;
  @Prop({
    default: true,
    type: Boolean,
  }) noResize!: boolean;
  @Prop({default: 'white'}) backgroundColor!: string;
  @Prop({default: true, type: Boolean}) showKeyboard!: boolean;


  sheet: boolean = false;

  get computedProps() {
    return {
      ...this.$props,
      outlined: true,
      noResize: true,
      backgroundColor: 'white',
      rules: [...this.rules,  (v) =>
          !/[^\x00-\x7F\u00E2\u00E4\u00E8\u00E9\u00EA\u00EB\u00EE\u00EF\u00F4\u0153\u00F9\u00FB\u00FC\u00FF\u00E7\u00C0\u00C2\u00C4\u00C8\u00C9\u00CA\u00CB\u00CE\u00CF\u00D4\u0152\u00D9\u00DB\u00DC\u0178\u00C7\u00F1\u00D1\u00E1\u00E9\u00ED\u00F3\u00FA\u00C1\u00C9\u00CD\u00D3\u00DA\u00A1\u003F\u00BF\u20AC]+/.test(
              v
          ) || i18n.t('globals.notUTF8Encoded')],
    };
  }

  onChange(input) {
    this.$emit('input', input);
  }
}
